import { useTypedParams } from '@sorare/routing';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';

import { RewardsEssenceLayout } from '@sorare/gameplay/src/layouts/rewards/RewardsEssenceLayout';

import { LayoutParams } from './__generated__/routeParams';

const NBARewardsEssenceLayout = () => {
  const { quality, rarity } = useTypedParams<LayoutParams>();
  return (
    <RewardsEssenceLayout quality={quality} rarity={rarity} sport={Sport.NBA} />
  );
};
export default NBARewardsEssenceLayout;
